import { Link } from 'react-router-dom';

import Button, { type ButtonProps } from '@/components/atoms/Button';

import IconLinkOrange from '@/assets/icons/LinkOrangeIcon.svg?react';
import { ExternalLinkIcon } from 'lucide-react';

export type LinkButtonProps = {
  children: React.ReactNode;
  to: string;
  target?: React.HTMLAttributeAnchorTarget;
} & ButtonProps;

const LinkButton = ({ children, target = '_blank', to, ...props }: LinkButtonProps) => {
  return (
    <Button
      className="text-primary hover:bg-point-200 flex h-[42px] items-center bg-point-100 active:bg-point-100"
      {...props}
    >
      <Link to={to} target={target} className="flex items-center space-x-[8px]">
        <div className="c-b6">{children}</div>
        <span>
          <ExternalLinkIcon width={16} height={16} className="text-gr-700" />
        </span>
      </Link>
    </Button>
  );
};

export default LinkButton;
